import $ from '@nuskin/nuskinjquery';
import cartModule from '../cartModule.js';
import {CartService, ErrorMessageList, ScanCardService, ScanCard} from '@nuskin/ns-shop';
import {events} from '@nuskin/ns-util';
import {getCachedConfigField} from '@nuskin/configuration-sdk';
import {getStrings} from '../services/ContentstackStringsProvider.js';

import {default as scanCardDirectiveHtml} from '../views/directives/scanCardDirective.html';

cartModule.directive('scanCards', [function() {
    /**
     * link
     *
     * @param {object} scope
     * @param {object} element
     * @param {object} attrs
     */
    function link(scope, element, attrs) {
        scope.scanCardError = new ErrorMessageList();
        getStrings()
            .catch((err) => {
                console.warn('unable to get translations from Contentstack.', err);
            })
            .then((strings) => {
                scope.tdc = strings;
                apply();
            });
        scope.scanCardErrorClass = '';
        scope.newScanNumber = '';
        scope.newScanName = '';
        scope.scanCardErrorClass = '';
        scope.scanCardError = new ErrorMessageList();
        scope.validatingScanNumber = false;
        scope.showName = getCachedConfigField('scanCardMkt') == 'yesWithName';
        scope.scanCards = CartService.getScanCards();

        checkInjectedScancard();

        scope.hideScanCardClass = function(editMode) {
            if (getCachedConfigField('scanCardMkt') === 'no' || (!editMode && scope.scanQualifiedCnt() === 0)) {
                return 'hide';
            }
            return '';
        };

        scope.scanQualifiedCnt = function() {
            return CartService.scanQualifiedCnt();
        };

        scope.moreScanCardsAllowed = function() {
            return scope.scanCards.length < scope.scanQualifiedCnt();
        };

        scope.scanCartLimitTxt = function() {
            return (scope.tdc || {scanCardLimitTxt: ''}).scanCardLimitTxt.replace('{scanCardCnt}', scope.scanQualifiedCnt());
        };

        scope.extraScanCardNumberClass = function() {
            return scope.scanCardErrorClass;
        };

        scope.clearScanCardInputs = function() {
            scope.newScanNumber = '';
            scope.newScanName = '';
            scope.scanCardError.clearErrors();
            scope.scanCardErrorClass = '';
            scope.validatingScanNumber = false;
        };

        scope.removeScanCard = function(cardNumber) {
            scope.scanCards = CartService.removeScanCard(cardNumber);
        };

        scope.validateScanCard = validateScanCard;

        /**
         *
         * @param {string} cardNumber
         */
        function validateScanCard(cardNumber) {
            scope.scanCardError.clearErrors();
            scope.scanCardErrorClass = '';
            if (CartService.hasScanCardNumber(cardNumber)) {
                scope.scanCardError.addErrorMessage('error', {text: scope.tdc.scanCardUsedErrorTxt});
            } else {
                scope.validatingScanNumber = true;
                ScanCardService.validateScanCard(cardNumber, scanCardCallbackFn);
            }
        }

        /**
         * checkInjectedScancard
         */
        function checkInjectedScancard() {
            const SCAN_CARD_COOKIE = 'parametersJSON';
            const parametersJSON = $.cookie(SCAN_CARD_COOKIE);
            let scancardName = '';
            if (parametersJSON && scope.scanCards.length < CartService.scanQualifiedCnt()) {
                const pObject = JSON.parse(parametersJSON);
                if (pObject.first_name) {
                    scancardName += pObject.first_name + ' ';
                }
                if (pObject.last_name) {
                    scancardName += pObject.last_name;
                }
                scope.newScanName = scancardName;
                if (pObject.scan_number && scope.newScanName !== '') {
                    scope.newScanNumber = pObject.scan_number;
                    validateScanCard(scope.newScanNumber);
                }
            }
        }

        /**
         * scanCardCallbackFn
         *
         * @param {object} response
         */
        function scanCardCallbackFn(response) {
            apply(function() {
                if (response.valid) {
                    CartService.addScanCard(new ScanCard({'cardNumber': scope.newScanNumber, 'cardName': scope.newScanName}));
                    scope.scanCards = CartService.getScanCards();
                    scope.newScanNumber = '';
                    scope.newScanName = '';
                    scope.scanCardErrorClass = '';
                } else {
                    scope.scanCardErrorClass = 'error';
                    scope.scanCardError.addErrorMessage('error', {
                        text: response.message ? response.message : scope.tdc.scanCardNotValidErrorTxt
                    });
                }
                scope.validatingScanNumber = false;
            });
        }

        /**
         * apply
         *
         * @param {function} _callback
         */
        function apply(_callback) {
            const callback = _callback || function() {};

            if (scope.$root.$$phase != '$apply' && scope.$root.$$phase != '$digest') {
                scope.$apply(callback);
            } else {
                callback();
            }
        }


        events.unsubscribe(events.shop.CART_SCAN_CARDS_CHANGED);
        events.subscribe(events.shop.CART_SCAN_CARDS_CHANGED, function(status) {
            if (status.type === 'trimmed') {
                scope.scanCards = status.scanCards;
            }
        });
        events.subscribe(events.shop.ADR_STATUS_CHANGE, function() {
            checkInjectedScancard();
        });
    }


    return {
        restrict: 'E',
        template: scanCardDirectiveHtml,
        scope: {},
        link: link
    };
}]);
